<script>
import { DxColumn, DxGrouping, DxGroupPanel } from 'devextreme-vue/data-grid'

export default {
  components: { DxColumn, DxGrouping, DxGroupPanel },
  props: {
    model: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      editing: {
        mode: 'cell',
        allowUpdating: true,
        allowDeleting: false,
        useIcons: true
      }
    }
  },
  computed: {
    dataSource: {
      get () {
        return this.model
      },
      set (val) {
        this.model = val
        this.$emit('change', val)
      }
    }
  }
}
</script>

<template>
  <dx-data-grid
    class="grid"
    :allow-column-reordering="true"
    :show-column-headers="true"
    :data-source="dataSource"
    :show-borders="true"
    :editing="editing"
  >
    <dx-column data-field="descricao" caption="Descrição" :allow-editing="false" />
    <dx-column data-field="visivel" caption="Vísivel" data-type="boolean" />
    <dx-column data-field="habilitado" caption="Habilitado" data-type="boolean" />
    <dx-column data-field="pedir_senha" caption="Pedir Senha" data-type="boolean" />
    <dx-column :group-index="0" data-field="tela_descricao" caption="Tela" />
    <dx-group-panel :visible="true" />
    <dx-grouping :auto-expand-all="true" />
  </dx-data-grid>
</template>

<style scoped>
  .grid {
    margin-top: 5px
  }
  .btn-acoes .dx-button {
    margin-left: 5px;
  }
</style>
